class GoogleSSOService {

    constructor(
        $http,
        appConfig,
    ) {
        'ngInject';

        this.$http = $http;
        this.appConfig = appConfig;
    }

    $onInit() {
        this.auth2 = null;
        this.loginErrorMessage = null;  
    }

    /***
     * Initialize the Google SSO auth2 API. This is a necessary step before the SSO
     * modal will load.
     */
    initGoogleSSO(googleClientId) {
        console.log('code move to controller')

    }
   

    /***
     * Sign the user into the Google system and then pass along the user information to our
     * API so we can authenticate the user with the server.
     */
    signIn() {
        return this.auth2.signIn();
    }
}

export default GoogleSSOService;


// WEBPACK FOOTER //
// ./app/components/google-sso-button/google-sso-button-service.js